import React from 'react'
import { Backdrop, Box, CircularProgress } from '@mui/material'
import loadingAnimation from '../../images/logo_animated.mp4'


const Loading = () =>
  <Backdrop open>
    <Box component='video' autoPlay='autoPlay' loop='loop' muted sx={{
      width: '100px',
      maxWidth: '70%',
    }}>
      <source src={loadingAnimation} type='video/mp4' />
      <CircularProgress size={20} />
    </Box>
  </Backdrop>

export default Loading
